import { AnimatedTabbar, AnimatedTabbarItem } from "../../components/AnimatedTabbar/AnimatedTabbar";

export function Sandbox() {
   return (
      <div>
         <AnimatedTabbar value={"tab1"}>
            <AnimatedTabbarItem name="tab1">Tab 1</AnimatedTabbarItem>
            <AnimatedTabbarItem name="tab2">Tab 2</AnimatedTabbarItem>
            <AnimatedTabbarItem name="tab3">Tab 3</AnimatedTabbarItem>
         </AnimatedTabbar>
      </div>
   );
}